// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-application--wrap > div[data-v-a4ce2ed0] {\n    height: 100%;\n}\n.drawer-comment-icon__fixed[data-v-a4ce2ed0] {\n    transform: translateY(-50%);\n    top: 50%;\n    position: fixed;\n    right: -30px;\n    z-index: 1;\n    border-radius: 20px;\n}\n.drawer-comment-icon__not-fixed[data-v-a4ce2ed0] {\n    right: 230px;\n    transition: all 300ms;\n}\n.v-navigation-drawer[data-v-a4ce2ed0] {\n    max-width: 800px !important;\n    z-index: 2;\n}\n", ""]);
// Exports
module.exports = exports;
